<section class="acceso">
	<div class="acceso-header fondo-blue"></div>
	<section class="acceso-form">
		<div class="acceso-form-image">
			<img src="assets/images/logo-big.png" alt="Pawerful PetShop" loading="lazy" />
		</div>
		<div class="acceso-form-content">
			<input [(ngModel)]="newUsuario.username" type="email" placeholder="Ingresa tu correo electrónico">
		</div>
		<div class="acceso-form-content">
			<input [(ngModel)]="password" type="password" placeholder="Ingresa tu contraseña">
		</div>
		<div class="acceso-form-content-controls">
			<button (click)="fnVerificarUsuario()" class="acceso-form-content-button fondo-purple">
				Ingresar
			</button>
			<button [routerLink]="[ '/registro' ]" class="acceso-form-content-button fondo-purple-outline">
				Crear cuenta
			</button>
		</div>
		<section>
			<p>
				<a [routerLink]="[ '/recuperacion' ]">¿Has olvidado tu contraseña? Recupérala <b class="color-blue">aquí</b></a>
			</p>
		</section>
	</section>
</section>